var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.968,
    height: 50.465,
    viewBox: "0 0 41.968 50.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(-6007.279 -6272.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M6007.873,6276.372v43.278a3,3,0,0,0,3,3h34.781a3,3,0,0,0,3-3V6282.9l-9.533-9.533h-28.248A3,3,0,0,0,6007.873,6276.372Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.188
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M6039.121,6273.459v9.457h9.365",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.188
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_242",
    "data-name": "Line 242",
    x2: 24.708,
    transform: "translate(6015.909 6291.881)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.188
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_243",
    "data-name": "Line 243",
    x2: 24.708,
    transform: "translate(6015.909 6298.428)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.188
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_244",
    "data-name": "Line 244",
    x2: 17.309,
    transform: "translate(6015.909 6304.975)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.188
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRequest);
export default __webpack_public_path__ + "static/media/icon-request.4d794053d194ec6570fd992f8d65b7c8.svg";
export { ForwardRef as ReactComponent };